import React from "react";
import PropTypes from "prop-types";
import "./Shape.css";

const Shape = ({ svgPath, color, className }) => {
  return (
    <div className={`shape ${className}`} style={{ fill: color }}>
      <img src={svgPath} alt="Shape" />
    </div>
  );
};

Shape.propTypes = {
  svgPath: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Shape.defaultProps = {
  className: "",
};

export default Shape;